import React, { useState } from "react";
import moment from "moment";
import FilePreviewModal from "../../../../../common/FilePreviewModal";
import { getOfficialIdDescription } from "../../../../TripEventLogic";
import { formatFullName } from "../../../../../../lib";

function RegistrationIdentification(props) {
  const {
    registration: {
      identification: {
        knownTravelerNumber,
        officialIdExpirationDate,
        officialIdNumber,
        officialIdDocumentUrl,
      },
      student: { legalFirstName, legalMiddleName, legalLastName },
    },
    requireIdentification,
  } = props;

  const [showOfficialIdDocumentPreview, setShowOfficialIdDocumentPreview] =
    useState(false);

  const officialIdDescription = getOfficialIdDescription(requireIdentification);

  return (
    <div className="trip-student-detail-tab identification-tab">
      <div className="student-detail-section">
        <div className="medium-text fw-700 mb-8">
          {officialIdDescription} Information
        </div>
        <div className="double-grid-container">
          <div className="two-column-grid">
            <p className="fw-700">Legal name</p>
            <p>
              {formatFullName(legalFirstName, legalLastName, legalMiddleName)}
            </p>
            <p className="fw-700">{officialIdDescription} number</p>
            <p data-private>{officialIdNumber}</p>
            <p className="fw-700">{officialIdDescription} expiration</p>
            <p>{moment(officialIdExpirationDate).format("MM/DD/YYYY")}</p>
          </div>
          <div className="two-column-grid">
            <p className="fw-700">Known traveler number</p>
            <p data-private>{knownTravelerNumber || "–"}</p>
            <p className="fw-700">Copy of {officialIdDescription}</p>
            <p
              className="flex flex-align-center link-text"
              onClick={() => setShowOfficialIdDocumentPreview(true)}
            >
              <i className="material-icons mr-8">description</i>
              {officialIdDescription}
            </p>
            <FilePreviewModal
              close={() => setShowOfficialIdDocumentPreview(false)}
              isSecure={true}
              show={showOfficialIdDocumentPreview}
              title={`Copy of ${officialIdDescription}`}
              url={officialIdDocumentUrl}
            />
            <p />
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(RegistrationIdentification);
